//state
const state = {
	menuModules:[],
	previledgeMenus:[],
	menusMap:{}
}

// getters
const getters = {
	getMenusMap(state){
		return state.menusMap;
	},
	getPreviledgeMenus(state){
		return state.previledgeMenus;
	},
	getMenuModules(state){
		return state.menuModules;
	}
}

// actions
const actions = {}

// mutations
const mutations = {
	setMenuModules (state,menuModules) {
		state.menuModules = menuModules;
	},
	setPreviledgeMenus (state,previledgeMenus) {
		state.previledgeMenus = previledgeMenus;
	},
	setMenusMap (state,menusMap) {
		state.menusMap = menusMap;
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
